export const capitalizeFirstLetter = (str: string): string => {
  const trimmed = str.trim();

  if (trimmed) {
    return trimmed.replace(/^\w/, (c) => c.toUpperCase());
  }
  return '';
};

export const formatCPF = (cpf:string) => {
  const cleanedCPF = cpf.replace(/\D/g, '');

  const formattedCPF = cleanedCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');

  return formattedCPF;
};

export const formatPhoneNumber = (phone: string) => {
  const cleaned = phone.replace(/\D/g, '');

  // DDD + Mobile (11 digits)
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  // DDD + Landline (10 digits)
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  // Mobile without DDD (9 digits)
  if (cleaned.length === 9) {
    return cleaned.replace(/(\d{5})(\d{4})/, '$1-$2');
  }

  // Landline without DDD (8 digits)
  if (cleaned.length === 8) {
    return cleaned.replace(/(\d{4})(\d{4})/, '$1-$2');
  }

  return phone;
};

export const formatMoney = (value?:number | null):string => (value
  ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
  : 'R$ 0,00');

export const parseStringNumberToFloat = (formattedValue: string): number => {
  const cleaned = formattedValue
    .replace(/\s/g, '')
    .replace('R$', '')
    .replace(/\./g, '')
    .replace(',', '.');

  const result = parseFloat(cleaned);
  return Number.isNaN(result) ? 0 : result;
};

export const onlyDigits = (text?: string | null): string => {
  if (!text) return '';
  return String(text).replace(/\D+/g, '');
}
